<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <vs-table :data="form.supporting_documentations"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container mb-8">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="30%">File Name</vs-th>
            <vs-th style="font-weight: normal" width="15%">Do you have this document?</vs-th>
            <vs-th style="font-weight: normal" width="20%">File</vs-th>
            <vs-th style="font-weight: normal" width="20%">Expiry Date</vs-th>
            <vs-th style="font-weight: normal" width="15%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{supporting_documentations_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].is_exist">
                <ValidationProvider :vid="indextr+'is_exist'" :name="indextr+'is_exist'" rules="" v-slot="{ errors }">
                  <vs-switch v-model="data[indextr].is_exist" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].file">
                <file-uploader-not-required v-on:onSetFileName="value => data[indextr].file = value" v-on:onClickFileRemove="data[indextr].file = null" :file="data[indextr].file" :condition="data[indextr].is_exist"/>
              </vs-td>

              <vs-td>
                <flat-pickr v-if="data[indextr].is_exist" :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="data[indextr].expiry_date"
                            placeholder="Choose Expiration Date"/>
              </vs-td>

              <vs-td :data="data[indextr].comment">
                <ValidationProvider :vid="indextr+'comment'" :name="indextr+'comment'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>


        <!--        <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        <div v-for="(supporting, index) in form.supporting_documentations" :key="index">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'legislative_name'" :name="index+'legislative_name'" rules="" v-slot="{ errors }">-->
        <!--&lt;!&ndash;                <small class="label">File Name</small>&ndash;&gt;-->
        <!--&lt;!&ndash;                <vs-input type="text" v-model="supporting.name" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />&ndash;&gt;-->
        <!--                <small class="label">File Name</small> <br>-->
        <!--                <span class="text-bold" style="font-weight: normal">{{ supporting.name}}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'is_exist'" :name="index+'is_exist'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Do you have this document?</small>-->
        <!--                <vs-switch v-model="supporting.is_exist" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
        <!--                  <span slot="on">Yes</span>-->
        <!--                  <span slot="off">No</span>-->
        <!--                </vs-switch>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0" v-if="supporting.is_exist" >-->
        <!--              <ValidationProvider :vid="index+'file'" :name="index+'file'" :rules="supporting.file ? '' : 'file_required'" v-slot="{ errors }">-->
        <!--                <small class="label">File</small>-->
        <!--                <a target="_blank" v-if="supporting.file" class="float-right" :href="supporting.file">view file</a>-->
        <!--                <vs-input style="color:transparent; width:70px;" type="file" @change="onUploadSupportingDocument($event, index)"  name="file" class="w-full"  :danger="errors[0]" :danger-text="errors[0]"  />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-2/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'comment'" :name="index+'comment'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Comment</small>-->
        <!--                <vs-input type="text" v-model="supporting.comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->



        <div v-for="(other, index2) in form.supporting_documentation_others" :key="index2">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_name'" :name="index2+'other_name'" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="other.name" type="text" name="name" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 md:mb-0">
              <ValidationProvider :vid="index2+'is_exist'" :name="index2+'is_exist'" rules="" v-slot="{ errors }">
                <small class="label">Do you have this document?</small>
                <vs-switch v-model="other.is_exist" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0" v-if="other.is_exist" >
              <small v-if="other.is_exist" class="label">File</small>
              <file-uploader-not-required v-on:onSetFileName="value => other.file = value" v-on:onClickFileRemove="other.file = null" :file="other.file" :condition="other.is_exist"/>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0" v-if="other.is_exist" >
              <small v-if="other.is_exist" class="label">Expiry Date</small>
              <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="other.expiry_date"
                          placeholder="Choose Expiration Date"/>
            </div>

            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button class="" @click="deleteOtherName(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button  @click="addOtherName" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Other Name</vs-button>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_supporting_document_complete"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import FileUploader from '@/components/shared/FileUploader'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: "SupplierManufacturingHome",
    components: {
      FileUploader,
      flatPickr,
    },
    data() {
      return {
        form: {
          supporting_documentation_others: [
            {
              "type": "other",
              "name": "",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
          ],
          supporting_documentations: [
            {
              "type": "main",
              "name": "specification",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "safety_data_sheet",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "food_grade",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "haccp_flow",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "gmo",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "rspo",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "migration",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "accreditation",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "halal",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "kosher",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            },
            {
              "type": "main",
              "name": "contaminant",
              "is_exist": false,
              "file": "",
              "expiry_date" : "",
              "comment": ""
            }
          ]
        },
        id: null,
        status: {},
        supporting_documentations_display_names: [
          'Specification', 'Safety Data Sheet', 'Natural and/or Food Grade Certificate / Statement',
          'HACCP Plan and Process Flow Diagram', 'GM IP certificate / GMO Free Statement / GMO Policy',
          'RSPO Certificate (If applicable) ', 'Migration Certificate (for packaging)', 'Accreditation certificates for manufacturing site and transport company',
          'Halal Certificate / Statement', 'Kosher Certificate / Statement', 'Contaminant / Pesticide Analysis Results and Accreditation Certificates'
        ]
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
      },
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_supporting_document_complete ? this.onClickUpdate() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (this.form.supporting_documentation_others.length === 0) {
            this.form.supporting_documentation_others = []
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialSupportingDocumentation(this.id, this.form))
          this.showSuccessMessage('Raw Material Supporting Documentation Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (this.form.supporting_documentation_others.length === 0) {
            this.form.supporting_documentation_others = []
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialSupportingDocumentation(this.form))
          this.showSuccessMessage('Raw Material Supporting Documentation Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialSupportingDocumentation(this.id)).data
        this.form = data
        if (this.form.supporting_documentation_others.length === 0) {
          this.addOtherName()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      addOtherName() {
        this.form.supporting_documentation_others.push(
          {
            "type": "other",
            "name": "",
            "is_exist": false,
            "file": "",
            "comment": ""
          },
        )
      },
      deleteOtherName(index) {
        this.form.supporting_documentation_others.splice(index, 1)
      },
      async onUploadOtherSupportingDocument(event, index){
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.supporting_documentation_others[index].file = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadSupportingDocument(event, index){
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.supporting_documentations[index].file = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_supporting_document_complete) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
